export enum PusherConnectionState {
  Initialized = 'initialized',
  Connecting = 'connecting',
  Connected = 'connected',
  Disconnected = 'disconnected',
  Failed = 'failed',
  Unavailable = 'unavailable',
}

export enum PusherChannelEvent {
  MESSAGE_ADDED = 'chat-message-added',
  MESSAGE_UPDATED = 'chat-message-updated',
  MESSAGE_DELETED = 'chat-message-deleted',
  CHANNEL_UPDATED = 'chat-channel-updated',
  CHANNEL_DELETED = 'chat-channel-deleted',
  MEMBER_ADDED = 'chat-member-added',
  MEMBER_REMOVED = 'chat-member-removed',
  TYPING_STARTED = 'chat-typing-started',
  MEMBER_UPDATED = 'chat-member-updated',
  USER_UPDATED = 'user-updated',
  CHANNEL_LIST_UPDATED = 'chat-channel-list-updated',
  ETS_TICKETS_UPDATED = 'ets-tickets-updated',
}

export type ChannelName =
  | `private-chat-channel-${string}`
  | `private-user-${string}`
  | `presence-current-user-${string}`;
